import OpenKnotsLoginFooter from 'components/openKnotsLogin/OpenKnotsLoginFooter'
import OpenKnotsLoginHero from 'components/openKnotsLogin/OpenKnotsLoginHero'
import '../OpenKnotsLogin.css'
import React from 'react'
import OpenKnotsForgotPasswordComponent from 'components/openKnotsLogin/OpenknotsForgotPasswordComponent'

function OpenKnotsForgotPassword() {
  return (
    <div className='opk-login'>
    <OpenKnotsLoginHero />
    <OpenKnotsForgotPasswordComponent />
    <OpenKnotsLoginFooter />
    </div>
  )
}

export default OpenKnotsForgotPassword